import {
  EventActions,
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export const useCarsCarouselTracking = () => {
  const trackEvent = useAnalytics((state) => state.trackEvent)

  const onVehicleClick = () => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.carCarousel,
        label: 'IndividualVehicle',
        action: EventActions.click,
      },
    }

    trackEvent({
      eventName: 'Click on individual vehicle',
      type: TrackingEventTypes.ADOBE,
      data: evt,
    })
  }

  const onBrowseAllCarsClick = () => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.carCarousel,
        action: EventActions.click,
        label: 'SearchButton',
      },
    }

    trackEvent({
      eventName: 'Click on search button of car carousel',
      data: evt,
      type: TrackingEventTypes.ADOBE,
    })
  }

  const onAddSaveVehicleClick = () => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.carCarousel,
        action: EventActions.click,
        label: 'FavouriteButton',
      },
    }

    trackEvent({
      eventName: 'Add vehicle to favourites',
      data: evt,
      type: TrackingEventTypes.ADOBE,
    })
  }

  const onRemoveSaveVehicleClick = () => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.carCarousel,
        action: EventActions.click,
        label: 'FavouriteButton',
      },
    }

    trackEvent({
      eventName: 'Remove vehicle from favourites',
      data: evt,
      type: TrackingEventTypes.ADOBE,
    })
  }

  return {
    onVehicleClick,
    onBrowseAllCarsClick,
    onAddSaveVehicleClick,
    onRemoveSaveVehicleClick,
  }
}
